var chunkToChildrenMap = {
	"7228": [
		33788,
		55967
	],
	"62968": [
		33788,
		55967
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };